<template>
  <div>
    <div class="background-animation">
      <div class="credits">
        <div class="congratulations">Congratulations</div>
        <div>Programming: Daniel Egger + Lorenz Padberg</div>
        <div>Art: Stephanie Rotzetter + Ramon Wenger</div>
        <div>Sound Programming: Kazam Zahedi</div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";
import sounds from "../sounds";

export default {
  name: "IntroScreen",
  data() {
    return {};
  },
  computed: {
    ...mapState(["gameState"])
  },
  methods: {
    onClickContinue: function() {
      console.log("onClickContinue, ");
      this.$store.dispatch("changeGameState", { name: "Game" });
    }
  },
  mounted() {
    sounds.playWinMusic();
  },
  beforeDestroy() {
    sound.stopWinMusic();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.background-animation {
  position: absolute;
  background: #361c35;
  background-image: url('../assets/Outro.gif');
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
}

.credits {
  .congratulations {
    font-size: 8vh;
  }

  margin-top: 70vh;
  font-size: 5vh;
  color: white;
}


</style>
